import { render, staticRenderFns } from "./Layout_Nav_Action.vue?vue&type=template&id=4823f924&"
import script from "./Layout_Nav_Action.vue?vue&type=script&lang=js&"
export * from "./Layout_Nav_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports